/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "368")


  
    
export interface API48448Item {
  
  /** 名称 */
  objName?: string;
  
  /** 编号 */
  okrONo?: string;
  
  /** 负责人 */
  flowName?: string;
  
  /** 周期 */
  activePeriod?: string;
  
  /** 所属部门 */
  departName?: string;
  
  /** kr列表 ,KrDataResult */
  krList?: API48448Item[];
  
};
    
  



export interface API48448Req {
  
  /** 负责人 */
  leaderName?: string;
    
  /** 周期 */
  activePeriod?: string;
    
  /** okr中krid */
  okrKrNo?: string;
    
  /** okro编号 */
  okrONo?: string;
    
};



export interface API48448Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** OkrDataResp  */
  data?: API48448Item[];
  /**   */
  exceptionMsg?: string;
  
};


// 48448 okr数据查询列表

export interface IUseGetAPI48448Return {
  /** okr数据查询列表: 接口请求状态 */
  isAPI48448Loading: boolean;
  /** okr数据查询列表: 接口请求返回数据 */
  dataAPI48448: API48448Res;
  /**  okr数据查询列表: 接口数据请求方法 */
  fetchAPI48448Data:  (inputs: API48448Req, config?: YWRequestConfig) => Promise<API48448Res>;
  /** okr数据查询列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI48448 = ():IUseGetAPI48448Return => {
  let isMount = true;
  const [isAPI48448Loading, setIsAPI48448Loading] = useState(false);
  const [dataAPI48448, setDataAPI48448] = useState<API48448Res>({} as API48448Res);
  const requestUrl = `${basePath}/internal-control-biz/project/okr/data/list`;

  const fetchAPI48448Data = async (inputs: API48448Req, config?: YWRequestConfig): Promise<API48448Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48448Req>) || {}) as API48448Req;
    
  
    if ( isMount ) {
      setIsAPI48448Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48448Res>(`${basePath}/internal-control-biz/project/okr/data/list?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48448(res || {} as API48448Res);
        setIsAPI48448Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48448Loading(false);
      }
      return false as unknown as API48448Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48448Loading,
    dataAPI48448,
    fetchAPI48448Data,
    requestUrl,
  }
}

